import React, { useState } from 'react';
import { Button, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import styled from '@emotion/styled';

interface ImageUploadPreviewProps {
  initialValue: string | null;
  setSelectedLogo: (file: File) => void;
}

const ImageUploadPreview: React.FC<ImageUploadPreviewProps> = ({
  initialValue,
  setSelectedLogo
}) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(initialValue);
  const [isError, setIsError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsError(false);
    setErrorMessage('');
    const file = event.target.files?.[0];
    if (file) {
      const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

      if (file.size > MAX_FILE_SIZE) {
        setIsError(true);
        setErrorMessage('File is too large. Maximum file size is 5 MB.');
        return;
      }
      if (!file.type.startsWith('image/') || file.type === 'image/gif') {
        setIsError(true);
        setErrorMessage('Please select a valid image file (PNG, JPG, JPEG, etc.).');
        return;
      }

      setSelectedLogo(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
  });

  return (
    <div className="flex flex-col items-center gap-4 p-4 w-full max-w-md mx-auto">
      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUploadIcon />}
      >
        Upload Logo
        <VisuallyHiddenInput
          onChange={handleImageChange}
          accept="image/*"
          type="file"
        />
      </Button>

      {isError && (
        <Typography color="error" mt={1}>
        {errorMessage}
      </Typography>
      )}
      <br />
      <br />
      {previewUrl && (
        <div className="flex flex-col items-center space-y-2">
          <div className="w-[200px] h-[200px] relative">
            <img src={previewUrl} alt="Logo" style={{ maxWidth: 200 }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageUploadPreview;
